var _defs, _rect, _text, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _polygon2, _polygon3, _polygon4, _polygon5, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _g2, _rect3, _path34, _rect4, _polygon6, _path35, _path36, _circle, _circle2, _polygon7, _g3, _g4, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailmarketing6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-22,.cls-23,.cls-26,.cls-27{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-15,.cls-3{fill:#2f2143;}.cls-4{fill:#2e1f42;}.cls-5{fill:#0a162f;}.cls-6{fill:#2e3052;}.cls-7{fill:#9a499c;}.cls-8{fill:#f5876d;}.cls-9{fill:#d45c49;}.cls-10{fill:#f8a692;}.cls-11{fill:#fff;}.cls-12{fill:#fbaa19;}.cls-13{fill:#f6891f;}.cls-14{fill:#fdcc51;}.cls-16{fill:#fdc435;}.cls-17{opacity:0.6;}.cls-17,.cls-20{isolation:isolate;}.cls-18{clip-path:url(#clip-path);}.cls-19{fill:#e5ac24;}.cls-20{opacity:0.7;}.cls-21{clip-path:url(#clip-path-2);}.cls-22,.cls-23{stroke:#2f2143;}.cls-22,.cls-23,.cls-26,.cls-27{stroke-miterlimit:10;}.cls-22{stroke-width:2px;}.cls-23{stroke-width:1.67px;}.cls-24{opacity:0.5;}.cls-25{opacity:0.8;}.cls-26,.cls-27{stroke:#524270;}.cls-27{stroke-dasharray:3.99 1.99;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1386.41,
    y: 175.12,
    width: 58.87,
    height: 50.57,
    transform: "translate(-14.05 186.64) rotate(-7.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1480.77,
    y: 156.56,
    width: 20.08,
    height: 22.76,
    transform: "translate(-9.16 196.15) rotate(-7.5)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EMAIL MARKETING 6.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(504.97 205.96)"
  }, "EMAIL MARKETING")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.22,153.08c8.59,31.27,36.91,40,36.91,40a85,85,0,0,0,25.41-9.64c-2.09-5-3-10.11-4.16-16.72-10.43,2.9-19.44,4.45-19.44,4.45-22-10.2-35.36-59-35.36-59C210.49,124.54,220.22,153.08,220.22,153.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.84,326l.37-2.23,11.13-67-35.72.76L186.35,326C197.17,326.18,206.79,326,218.84,326Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "213.05 326 195.85 257.54 146.48 260.78 179.72 326 213.05 326"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M223.58,112.12c2.49,3.11,7.5,34.84,8.28,67l.06,2.22c.08,3.41.15,6.84.22,10.26s.13,6.75.18,10.1c.09,5.48.17,10.87.24,16.07,0,.59,0,1.17,0,1.76.06,5.07.11,9.92.14,14.46,0,.59,0,1.18,0,1.76,0,6.81.08,12.84.09,17.68h0v1.95c0,3.39,0,6.07,0,7.88A168.69,168.69,0,0,1,208.75,268l-.64.08-1.06.13-.27,0c-1.39.15-2.77.29-4.17.4a160.26,160.26,0,0,1-20.67.37l-1.81-.09c-.53,0-1.08-.06-1.63-.11l-.73,0-1.38-.1A168.72,168.72,0,0,1,146,263.3c-.06-4-.1-12.11-.12-22.58V239c0-11.55,0-25.74.17-40.34,0-1.16,0-2.31,0-3.47,0-1.34,0-2.68,0-4,0-.23,0-.46,0-.69s0-.63,0-.95l0-1.9c0-.93,0-1.85,0-2.77l0-2.09q0-2.1.06-4.17c.49-29,1.47-55.63,3.33-62.41a5.24,5.24,0,0,1,.54-1.36,9.29,9.29,0,0,1,.72-.92,13.84,13.84,0,0,1,1.21-1.22c3.1-2.86,8.49-6.18,14-9.33l1.91-1.09c.09,0,14.84-5,14.93-5.08l15.43,1.08S219.91,107.55,223.58,112.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.35,153.89a.8.8,0,0,0-1.44-.49,79.71,79.71,0,0,0-12.15,24.1c-.57,1.81-1.06,3.56-1.48,5.23l0,2.09c0,.92,0,1.84,0,2.77l0,1.9c0,.32,0,.64,0,.95s0,.46,0,.69a96.78,96.78,0,0,1,3.14-13.19,78,78,0,0,1,11.88-23.57.76.76,0,0,0,.17-.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.48,238h0c16.65-.07,30.87-7.65,39.86-14A91.15,91.15,0,0,0,220,210.16a.8.8,0,0,0-.1-1.13.81.81,0,0,0-1.13.09,89.15,89.15,0,0,1-15.41,13.64c-8.8,6.2-22.69,13.61-38.91,13.68a.8.8,0,1,0,0,1.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.84,243.7c14.45,0,28.87-8.24,29.52-8.62a.79.79,0,0,0,.29-1.09.8.8,0,0,0-1.09-.29c-.17.09-17.13,9.78-32.17,8.22a.8.8,0,0,0-.16,1.6C179.43,243.64,180.64,243.7,181.84,243.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.7,123.56c13.93-3.86,25.62-15.64,26.15-16.18a.81.81,0,1,0-1.15-1.13c-.13.14-13.89,14-28.79,16.52a.8.8,0,1,0,.26,1.58A32.72,32.72,0,0,0,177.7,123.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.05,58.55c0,14.08,8.66,23.79,22.75,23.79s23.89-10.43,23.89-24.52-8.34-24.75-22.42-24.75C173.38,33.07,166.05,44.47,166.05,58.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.37,62.29s-4.93-7.44-2.32-13.18c2.69-5.94,1.32-4.64,2-9.1s3.92-6.29,7.81-6.94,1.23-5.12,6.62-6.73,9.71,4,13.18,1.5,12-3.76,14.37,0,4.52,3.74,7.07,3.62c3.07-.15,7.19,4.7,4.41,9.15s-7.45,2.69-6.81,5.76,4.6,8.48-.7,15.35C210.39,63.8,166.37,62.29,166.37,62.29Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.21,64.62s-3.91-5.22-6.82-.91,1.2,17.06,8.32,13.95Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.16,73.72a.6.6,0,0,1-.58-.44c-1.1-3.93-5.18-5.53-5.22-5.54a.6.6,0,1,1,.43-1.13c.19.07,4.68,1.82,6,6.35a.6.6,0,0,1-.42.74Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165,71.74a.55.55,0,0,1-.32-.1.6.6,0,0,1-.18-.83A5.42,5.42,0,0,1,166.8,69a.59.59,0,0,1,.79.3.6.6,0,0,1-.3.8,4.35,4.35,0,0,0-1.74,1.37A.6.6,0,0,1,165,71.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.53,64.62s3.91-5.22,6.82-.91-1.2,17.06-8.33,13.95Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M209.58,73.72a.61.61,0,0,0,.58-.44c1.1-3.93,5.18-5.53,5.22-5.54a.61.61,0,0,0,.35-.78.61.61,0,0,0-.78-.35c-.19.07-4.68,1.82-5.95,6.35a.6.6,0,0,0,.42.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M213.69,71.74a.58.58,0,0,0,.33-.1.6.6,0,0,0,.18-.83A5.42,5.42,0,0,0,211.94,69a.6.6,0,1,0-.49,1.1,4.45,4.45,0,0,1,1.74,1.37A.58.58,0,0,0,213.69,71.74Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199,88.46v13.41a9.29,9.29,0,0,1-6.29,3.62c-5.88.7-12.24-5.51-12.24-5.51V89.35Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M199,88.46v5.63c-3.43,3.8-9.52,4.75-18.53,3.42V89.35Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M167.13,64.38c.05.73.11,1.47.19,2.22.19,1.89.44,3.83.79,5.76l0,.19c1.7,9.35,5.53,18.53,13.77,21.48,18.68,6.66,25.34-9.35,28-18.68.29-1,.56-2.19.79-3.42l0-.16c.26-1.38.49-2.85.68-4.37.14-1.12.26-2.26.37-3.41.27-2.79.45-5.58.57-8.07A13.18,13.18,0,0,0,203.91,43c-7.66-2.94-19.28-5.27-30.3,1a13.26,13.26,0,0,0-6.72,11.26C166.85,57.8,166.89,61,167.13,64.38Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.13,64.38c.05.73.11,1.47.19,2.22.19,1.89.44,3.83.79,5.76l0,.19c1.7,9.35,5.53,18.53,13.77,21.48,18.68,6.66,25.34-9.35,28-18.68.29-1,.56-2.19.79-3.42l0-.16c.26-1.38.49-2.85.68-4.37.14-1.12.26-2.26.37-3.41l-2.8.73c-.8,4.23-2,10.39-3.56,13.26-2.45-6-16.06-1-16.06-1s-12.14-4.32-16.25,0a111.92,111.92,0,0,1-3.69-12.19ZM189,79.15c9.8-1.34,12.23,1.16,12.69,4.06a16.94,16.94,0,0,1-8.35,5c-3.36.76-10.17.69-15.14-3.22C177.68,82.75,177.11,76.16,189,79.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183,65.36c0,1.35-.7,2.45-1.56,2.45s-1.55-1.1-1.55-2.45.69-2.45,1.55-2.45S183,64,183,65.36Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.08,65.36c0,1.35-.69,2.45-1.55,2.45S198,66.71,198,65.36s.7-2.45,1.56-2.45S201.08,64,201.08,65.36Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.93,57S199,55,195.24,56.65l.38,2.1s5.55-.47,8.35.67A3.65,3.65,0,0,0,203.93,57Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.31,57s4.92-1.94,8.7-.31l-.38,2.1s-5.55-.47-8.35.67A3.65,3.65,0,0,1,175.31,57Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190,76a6.63,6.63,0,0,1-2.22-.19.6.6,0,1,1,.32-1.16,3.65,3.65,0,0,0,2.42-.07.68.68,0,0,0,.23-.59c0-2.12-1.47-9-1.48-9.11a.6.6,0,0,1,1.18-.24,89,89,0,0,1,1.5,9.32,1.84,1.84,0,0,1-.69,1.57A2.61,2.61,0,0,1,190,76Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M181.75,79.59c.49,2.47,2.13,7,7.64,7s7.06-4.16,7.6-7Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.72,64.72H209c.3-2.74-.69-6-1.51-8.25-1.87-5,2.1-7.21-1.11-9.71s-11.19-1.43-16.75-1.61-14.56-.11-16.74.4-1,4.13-.19,6.94-2.68,5.91-3.26,8.82a12.82,12.82,0,0,0,0,3.41h-2.27c-.27-3.54-.31-6.83-.26-9.5A13.23,13.23,0,0,1,173.61,44c11-6.24,22.65-3.91,30.3-1a13.18,13.18,0,0,1,8.45,12.93C212.23,58.62,212,61.69,211.72,64.72Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 156.32,
    y: 116.11,
    width: 153.03,
    height: 105.71,
    transform: "translate(-45.72 240.86) rotate(-50.44)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "240.81 76.32 246.04 80.64 249.59 182.81 148.58 198.61 143.36 194.3 244.54 178.65 240.81 76.32"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "224.87 181.51 227.67 258.2 224.85 261.62 222.77 259.9 219.92 181.69 224.87 181.51"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.51 142.15 322.31 143.64 319.23 147.37 243.39 159.09 242.64 154.19 320.51 142.15"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "143.35 194.3 244.54 178.65 240.81 76.32 143.35 194.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.46,224h2.81a6.14,6.14,0,0,0,5.55-3.72c.5-1,1.18-2.81,1.64-3.43,1.32-1.76,4.9-4.7,6.25-4.79s1.09,2.41.14,3.51a22.59,22.59,0,0,0-3.25,4c-.8,1.55,6.58,4.69,9.57,5.42s8.25-.88,8.77,1.6-3.44,2.85-3.44,2.85,1.16,2.24-2.11,4.09a3,3,0,0,1-1.54,3.36s.24,2.78-2.22,3.51-10.12,3-25.17-6.18Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.83,160.17c5.68,21.47,11.25,31,11.25,31s6.38,9.73,19.47,19c9.1,6.4,23.72,14,23.72,14-2.52,3.28-4.3,9.76-3.33,11.7-30.39,0-57-28.79-57-28.79-21.26-37-22.65-67.14-22.3-78.12A20.91,20.91,0,0,1,147.05,118a10.89,10.89,0,0,1,4.08-4,22.13,22.13,0,0,1,12.29,14.09C166.59,138.77,171.83,160.17,171.83,160.17Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M307.17,162.07s-6.76-2.39-9.87-1.1,5.51,6,5.51,6-10.44-5.56-12.24-3.32,8.18,7.93,8.18,7.93-7.65-2.69-9.2-1.11,5.58,6,5.58,6-6.28-1.52-7.59-.45,4.25,5.53,7.78,6.72,4.1-3.79,4.1-3.79,3.32-2.92,2.88-4.95c0,0,3.45-2.33,3.69-4.7C306,169.29,310.85,165,307.17,162.07Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1424.42,266.54l5.09-2.31a6.49,6.49,0,0,0,3.49-7.54L1421.61,215l-13.88,6.37,7.73,40.54a6.36,6.36,0,0,0,7.39,5.13,6.25,6.25,0,0,0,1.57-.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1382.37,215.83c-1.11-2.38-2.17-4.73-3.16-7.07a42.1,42.1,0,0,1,11.59-14c2.26,4.49,4.54,9.2,6.8,14.07s4.31,9.68,6.21,14.35a42.71,42.71,0,0,1-18.18-.35c-1.1-2.3-2.2-4.61-3.26-7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1391.56,211.63a89.83,89.83,0,0,1-6.27-17.8l45.52-20.9,15.59,34-45.55,20.93a90.52,90.52,0,0,1-9.29-16.26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1391.56,211.63a89.83,89.83,0,0,1-6.27-17.8l45.52-20.9,15.59,34-45.55,20.93a90.52,90.52,0,0,1-9.29-16.26"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1418.71,175.09c2-1,48.55-57.1,54-59.79s20.85,16.88,33.21,43.83,17.5,51,11.54,53.76-78.46,1-80.55,1.93-8.5-6.9-13.53-17.89-7.3-20.71-4.7-21.84"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1484.27,169.06c12.37,26.95,27.25,46.55,33.22,43.83s.84-26.65-11.54-53.76-27.24-46.55-33.21-43.83-.83,26.85,11.53,53.76"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1498.55,162.43c.83,1.8,1.62,3.67,2.36,5.32a45.34,45.34,0,0,1-11.68,11.88c-1.72-3.35-3.44-6.9-5.15-10.56s-3.21-7.33-4.67-10.79A45.62,45.62,0,0,1,1496,157.2a23.89,23.89,0,0,1,2.52,5.23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1498.55,162.43c.83,1.8,1.62,3.67,2.36,5.32a45.34,45.34,0,0,1-11.68,11.88c-1.72-3.35-3.44-6.9-5.15-10.56s-3.21-7.33-4.67-10.79A45.62,45.62,0,0,1,1496,157.2a23.89,23.89,0,0,1,2.52,5.23"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 453.23,
    y: 45.6,
    width: 46.67,
    height: 46.67,
    rx: 8.5,
    transform: "translate(-4.9 61.02) rotate(-7.29)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M488.45,57.73l-.35-.93a7.6,7.6,0,0,0-4-4.12,2.18,2.18,0,0,0-2.74.91c-1.09,1.72-2.18,3.45-3.25,5.18a2.25,2.25,0,0,0,.72,3.11c.77.52,1.57,1,2.37,1.5.1.06.21.1.3.15a20.81,20.81,0,0,1-7.41,11.84l-1.73-1.1c-.3-.19-.6-.39-.91-.56a2.21,2.21,0,0,0-2.69.2,3.53,3.53,0,0,0-.63.8c-1,1.55-1.95,3.12-2.94,4.68a3,3,0,0,0-.49,1.59c0,.21.09.42.14.62a4.91,4.91,0,0,0,.75,1A8,8,0,0,0,468.1,84a6.59,6.59,0,0,0,3.38.24,13.32,13.32,0,0,0,2.19-.71,18.22,18.22,0,0,0,4.9-3.19A27.44,27.44,0,0,0,482.49,76a45.39,45.39,0,0,0,4.08-6.7,22.24,22.24,0,0,0,2.09-5.8,13,13,0,0,0,.22-3.11c0-.42-.07-.84-.11-1.26S488.56,58.2,488.45,57.73Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1039.05,
    y: 40.59,
    width: 46.84,
    height: 75.19,
    transform: "translate(584.36 1030.22) rotate(-67.54)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1036.67 42.18 1062.47 78.18 1106.16 70.9 1036.67 42.18"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M335.57,291.77a24.72,24.72,0,1,1,41.89-26.25"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M346.44,244.41a9.64,9.64,0,1,1-13.29-3,9.65,9.65,0,0,1,13.29,3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 1303.09,
    cy: 89.51,
    r: 20.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 57.68,
    cy: 73.72,
    r: 17.4
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1035.86 272.02 1057.28 282.95 1059.46 300.48 1072.42 288.94 1090.7 296.6 1141 245.69 1035.86 272.02"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1057.28 282.95 1139.42 246.08 1095.95 270.65 1067.35 286.81 1059.46 300.48 1059.46 300.48 1057.28 282.95"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1067.35 286.81 1072.42 288.94 1059.46 300.48 1067.35 286.81"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1059.46,300.48l-2,.29"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1055.5,301.05c-199,28.31-277.19-9.47-309.46-54.79-29.33-41.19-30.7-102.59-84.52-126.26-31.36-13.79-73.25-11.57-94.56-10.43-18.21,1-41.14,2.18-67.7,11.34-71.69,24.75-89.16,78.58-132.26,72-4.61-.7-21.28-3.25-31-17.08-8.14-11.54-7.33-25.05-6.28-31.77"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M329.84,143.09c.14-.78.27-1.44.38-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailmarketing6);
export default __webpack_public_path__ + "static/media/EMAIL MARKETING 6..89189fb28ecbc608daa5482fc4c1a261.svg";
export { ForwardRef as ReactComponent };